import React from 'react';

import Text from 'components/Text';
import Image from 'components/Image';
import Heading from 'components/Heading';
import Row from 'components/Row';

type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
};

const ComposerIntegrationsContentEmpty = ({ header = 'No content found.', children }: Props) => (
  <Text align="center" className="ComposerIntegrationsContentEmpty">
    <Row size="large">
      <Image src={require('assets/images/telescope.svg')} width="104px" />
    </Row>
    <Row size="xsmall">
      <Heading level="2" flush>
        {header}
      </Heading>
    </Row>
    <Text color="graphite">{children}</Text>
  </Text>
);
export default ComposerIntegrationsContentEmpty;
